import request from "@/utils/request";

export function getUsers(params) {
  return request({
    url: `/users/`,
    method: `get`,
    params,
  });
}

export function getUsersId(id) {
  return request({
    url: `/users/${id}/`,
    method: `get`,
  });
}

export function postUsers(data) {
  return request({
    url: `/users/`,
    method: `post`,
    data,
  });
}

export function putUsersId(id, data) {
  return request({
    url: `/users/${id}/`,
    method: `put`,
    data,
  });
}
